"use client"

import Link from "next/link"
import { Lock } from "lucide-react"

import { ColdApproachWordmark } from "@/components/marketing/cold-approach-wordmark"

// CHECKOUT CHROME (owner, 2026-08-20, his highest-priority checkout change):
// someone who has reached a $3,000 checkout must not be able to wander back
// into Coaching / Done For You / Articles — "they already made the product
// decision." So both ends of the chrome swap for these minimal pieces on the
// /pay routes. These are the COMPONENTS of real module instances
// (mastheads.checkout and footers.checkout); route selection lives in the
// layout's ChromeSwitch, never here.

/** His header: the lockup and a secure-checkout marker. Nothing else — no
 *  dropdown navigation, no Apply, no product browsing. The lockup still
 *  links home, the one standard escape hatch. */
export function CheckoutMasthead() {
  return (
    <header className="sticky top-0 z-40 border-b border-[var(--color-rule)] bg-white">
      <div className="mx-auto flex h-16 max-w-[92rem] items-center justify-between px-5 py-3 sm:px-8 lg:px-10">
        <Link
          href="/"
          aria-label="Cold Approach home"
          className="flex h-10 shrink-0 items-center text-[var(--color-ink)] transition-opacity hover:opacity-80"
        >
          <ColdApproachWordmark size={90} decorative />
        </Link>
        <span className="inline-flex items-center gap-2 text-[0.82rem] font-semibold text-[var(--color-ink-muted)]">
          <Lock aria-hidden size={14} className="shrink-0 text-[var(--color-vermilion)]" />
          Secure checkout
        </span>
      </div>
    </header>
  )
}

/** His footer: one legal line. No newsletter, no social media, no columns. */
const CHECKOUT_FOOTER_LINKS = [
  { href: "/terms-and-conditions", label: "Terms" },
  { href: "/refund-policy", label: "Refund Policy" },
  { href: "/privacy-policy", label: "Privacy" },
] as const

export function CheckoutFooter() {
  return (
    <footer className="border-t border-[var(--color-rule)] bg-white px-5 py-6 sm:px-8">
      <div className="mx-auto flex max-w-[92rem] flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[0.8125rem] text-[var(--color-ink-muted)]">
        {/* The brand name, not the domain (owner, 2026-08-20). */}
        <span>&copy; {new Date().getFullYear()} Cold Approach</span>
        {CHECKOUT_FOOTER_LINKS.map((link) => (
          <Link
            key={link.href}
            href={link.href}
            className="tap-target transition-colors hover:text-[var(--color-ink)]"
          >
            {link.label}
          </Link>
        ))}
      </div>
    </footer>
  )
}
